import React, { useLayoutEffect, useRef } from 'react'
import './PlaylistItem.scss'
import { handleKeyDown } from '../../utils/keyboard'

export const toHHMMSS = (ms) => {
  const sec = ms / 1000
  var sec_num = parseInt(sec, 10) // don't forget the second param
  var hours = Math.floor(sec_num / 3600)
  var minutes = Math.floor((sec_num - hours * 3600) / 60)
  var seconds = sec_num - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  if (hours > 0) return hours + ':' + minutes + ':' + seconds
  return minutes + ':' + seconds
}

const PlaylistItem = (props) => {
  const divRef = useRef(null)

  useLayoutEffect(() => {
    if (!props.isSelected)
      return;

    const offsetTop = divRef.current.offsetTop - props.playlistRef.current.offsetTop;
    props.playlistRef.current.scrollTop = offsetTop;
  }, [])
  return (
    <div
      ref={divRef}
      className={`PlaylistItem d-flex flex-row ${props.isSelected ? 'selected' : ''
        }`}
      onClick={() => (props.updateVideo(props.item, true, false))}
      tabIndex="0"
      role="listitem"
      aria-label={`${props.isSelected ? 'Currently playing' : ''
        } video segment from ${props.item.name}`}
      onKeyDown={(e) =>
        handleKeyDown(e, [13], () => props.updateVideo(props.item, true, true))
      }
    >
      <img
        className="img img-thubmnail"
        alt={`${props.item.name}`}
        src={props.item.thumbnail}
      />
      <div className="mx-2 text-s">
        <h6 className="bold headline">{props.item.name}</h6>
        <div className="description">{props.item.description}</div>
        <div className="text-muted" aria-label="video length">
          {toHHMMSS(props.item.duration)}
        </div>
      </div>
    </div>
  )
}

export default PlaylistItem
